import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'

import { Box, Button, Tooltip } from '@material-ui/core'

import { MenuButton, Permitted } from 'components'
import { AuditsFinalizeModal, AuditsInactivationModal } from '..'

import constants from 'constants/index'

const AuditsActions = ({ companyAudit, setLoading, refresh }) => {
  const [open, setOpen] = useState(false)
  const [openInactivationModal, setOpenInactivationModal] = useState(false)

  const handleOpenModal = () => setOpen(true)
  const handleOpenInactivationModal = () => setOpenInactivationModal(true)

  const isPreview = companyAudit?.status === constants.audits.PREVIEW_STATUS_ID
  const isInactive =
    companyAudit?.status === constants.audits.INACTIVE_STATUS_ID

  return (
    <Box>
      <Permitted
        someTags={[
          constants.permissions.AUDITS.MANAGE,
          constants.permissions.AUDITS.FINALIZE,
        ]}
      >
        <MenuButton>
          <Fragment>
            <Permitted tag={constants.permissions.AUDITS.MANAGE}>
              <Button onClick={handleOpenInactivationModal}>
                {isInactive ? 'Ativar' : 'Inativar'}
              </Button>
            </Permitted>
            <Permitted tag={constants.permissions.AUDITS.FINALIZE}>
              <Tooltip
                title={
                  isPreview || isInactive
                    ? `Não é possível finalizar uma auditoria ${
                        isPreview ? 'prevista' : 'inativada'
                      }`
                    : ''
                }
              >
                <Box>
                  <Button
                    onClick={handleOpenModal}
                    disabled={isPreview || isInactive}
                  >
                    Finalizar
                  </Button>
                </Box>
              </Tooltip>
            </Permitted>
          </Fragment>
        </MenuButton>
        <AuditsFinalizeModal
          companyAuditId={companyAudit?.id}
          open={open}
          setLoading={setLoading}
          setOpen={setOpen}
          refresh={refresh}
        />
        <AuditsInactivationModal
          companyAuditId={companyAudit?.id}
          isInactive={isInactive}
          open={openInactivationModal}
          setLoading={setLoading}
          setOpen={setOpenInactivationModal}
          refresh={refresh}
        />
      </Permitted>
    </Box>
  )
}

AuditsActions.propTypes = {
  companyAudit: PropTypes.object,
  refresh: PropTypes.func,
  setLoading: PropTypes.func.isRequired,
}

export default AuditsActions
